// File: frontend/src/components/Admin/RoomsManagement.jsx

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { roomsAPI } from '../../services/api';

export default function RoomsManagement() {
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    roomsAPI.getAll().then(setRooms).catch(() => {});
  }, []);

  return (
    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow">
      <h3 className="font-semibold mb-2">Rooms</h3>
      <div className="flex gap-2 mb-2">
        <Link to="/admin/rooms" className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm">
          Manage Rooms
        </Link>
      </div>
      <div className="border rounded p-2 max-h-40 overflow-y-auto">
        {rooms.length > 0 ? (
          rooms.map(room => (
            <div key={room.id} className="p-1 hover:bg-gray-100 text-xs">{room.name}</div>
          ))
        ) : (
          <p className="text-xs text-gray-400 dark:text-gray-500 italic py-2 text-center">No rooms created yet.</p>
        )}
      </div>
    </div>
  );
}
